import React, { useEffect, useState, useRef } from "react";
import MapComponent from "././MapComponent";
import { Button, Select } from "antd";
import html2canvas from "html2canvas";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { map } from "leaflet";
import { ClipLoader } from "react-spinners";
import "./style.css";
const { Option } = Select;

const Map = () => {
  const allOptionValue = "__ALL__";

  const [isDarkMode, setIsDarkMode] = useState(
    document.body.classList.contains("dark-mode")
  );

  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [loadingMap, setLoadingMap] = useState(false);
  const [carName, setCarName] = useState("Not Selected");
  const [mapCoordinates, setMapCoordinates] = useState({
    latitude: 18.1096,
    longitude: -77.2975,
  });
  const position = [51.505, -0.09];

  const handleSeeLocation = async (location, name) => {
    setLoadingMap(true);
    const [latitude, longitude] = location.split(", ").map(Number);
    await setMapCoordinates({ latitude, longitude });
    await setCarName(name);
    setLoadingMap(false);
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDarkMode(document.body.classList.contains("dark-mode"));
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="map">
      <div className="map-title">Fuel Theft</div>

      <div className="actions">
        <Select
          popupClassName="custom-select-dropdown"
          className="select-menu hide-on-export"
          mode="multiple"
          style={{ width: "100%" }}
          placeholder="Select Vehicle/s to Display..."
          maxTagCount="responsive"
        ></Select>
      </div>
      <div className="removal-content">
        <div className="left-content">
          {loadingMap ? (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="loader-container"
            >
              <ClipLoader size={50} color={"#123abc"} loading={loadingMap} />
            </div>
          ) : (
            <MapComponent
              name={carName}
              latitude={mapCoordinates?.latitude}
              longitude={mapCoordinates?.longitude}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Map;
